import { Column } from "@carbon/react";

export const View = ({ sm, md, lg, children, ...rest }) => {
  return (
    <Column sm={sm} md={md} lg={lg} {...rest}>
      {children}
    </Column>
  );
};
